module.exports = __webpack_public_path__ + "img/atalho-6.fcff65d0.png";